import { render, staticRenderFns } from "./ProjectConfigurations.vue?vue&type=template&id=5a15aa7e&scoped=true"
import script from "./ProjectConfigurations.vue?vue&type=script&lang=js"
export * from "./ProjectConfigurations.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfigurations.vue?vue&type=style&index=0&id=5a15aa7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a15aa7e",
  null
  
)

export default component.exports